import { Button } from '@uroute/ui';
import { useEffect, useState } from 'react';
import {
  applyUpdate,
  isIosSafari,
  onUpdateAvailable,
  useInstall,
} from '../lib/install';
import { Download, RefreshCw, XIcon } from './icons';

export function InstallPrompt() {
  const { canInstall, installed, dismissed, promptInstall, dismiss } = useInstall();
  const [instructions, setInstructions] = useState(false);

  if (installed || dismissed) return null;

  const ios = isIosSafari();
  if (!canInstall && !ios) return null;

  return (
    <div className="installbar" role="region" aria-label="Install the UR-ROUTE driver app" data-testid="install-prompt">
      <img src="/logo-icon-t.png" alt="" className="installbar__logo" />
      <div className="installbar__body">
        <p className="installbar__title">Add UR-ROUTE to your home screen</p>
        <p className="installbar__text">
          {ios
            ? 'Tap the Share button in Safari, then choose “Add to Home Screen”.'
            : 'Install the driver app for full-screen access and offline job lists.'}
        </p>
        {instructions ? (
          <ol className="installbar__steps">
            <li>Open Safari and tap the Share icon.</li>
            <li>Scroll down and tap “Add to Home Screen”.</li>
            <li>Tap Add — UR-ROUTE opens like a normal app.</li>
          </ol>
        ) : null}
      </div>
      <div className="installbar__actions">
        {canInstall && !ios ? (
          <Button
            variant="primary"
            size="sm"
            onClick={() => void promptInstall()}
            data-testid="install-prompt-install"
            className="installbar__cta"
          >
            <Download size={16} />
            Install
          </Button>
        ) : null}
        {ios ? (
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setInstructions((v) => !v)}
            data-testid="install-prompt-how"
            className="installbar__cta"
          >
            How
          </Button>
        ) : null}
        <button
          type="button"
          className="installbar__close"
          onClick={dismiss}
          aria-label="Dismiss install prompt"
          data-testid="install-prompt-dismiss"
        >
          <XIcon size={16} />
        </button>
      </div>
    </div>
  );
}

export function UpdatePrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => onUpdateAvailable(() => setVisible(true)), []);

  if (!visible) return null;

  return (
    <div className="updatebar" role="status" data-testid="update-prompt">
      <RefreshCw size={16} className="updatebar__icon" />
      <span className="updatebar__text">A new version of UR-ROUTE is available.</span>
      <Button
        variant="primary"
        size="sm"
        onClick={() => void applyUpdate()}
        data-testid="update-prompt-refresh"
        className="updatebar__cta"
      >
        Refresh
      </Button>
      <button
        type="button"
        className="updatebar__close"
        onClick={() => setVisible(false)}
        aria-label="Dismiss update notice"
        data-testid="update-prompt-dismiss"
      >
        <XIcon size={16} />
      </button>
    </div>
  );
}
